{
  "AGENT_BOTS": {
    "HEADER": "Boty",
    "LOADING_EDITOR": "Načítava sa editor...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Zistiť viac o agentských botoch",
    "GLOBAL_BOT": "Systémový bot",
    "GLOBAL_BOT_BADGE": "Systémový",
    "AVATAR": {
      "SUCCESS_DELETE": "Avatar bota bol úspešne smazán",
      "ERROR_DELETE": "Chyba pri mazanie avataru bota, zkuste to znovu"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Bot name",
        "PLACEHOLDER": "Name your bot.",
        "ERROR": "Bot name is required."
      },
      "DESCRIPTION": {
        "LABEL": "Bot description",
        "PLACEHOLDER": "What does this bot do?"
      },
      "BOT_CONFIG": {
        "ERROR": "Please enter your CSML bot configuration above.",
        "API_ERROR": "Your CSML configuration is invalid. Please fix it and try again."
      },
      "SUBMIT": "Validate and save"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Vyberte agentského bota",
      "DESC": "Priraďte agentského bota k vašej schránke. Boty dokážu spracovať počiatočné konverzácie a v prípade potreby ich preposlať živému agentovi.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Aktualizovať",
      "DISCONNECT": "Odpojiť bota",
      "SUCCESS_MESSAGE": "Agentský bot bol úspešne aktualizovaný.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Agentský bot bol úspešne odpojený.",
      "ERROR_MESSAGE": "Nepodarilo sa aktualizovať agentského bota. Skúste to prosím znova.",
      "DISCONNECTED_ERROR_MESSAGE": "Nepodarilo sa odpojiť agentského bota. Skúste to prosím znova.",
      "SELECT_PLACEHOLDER": "Vyberte bota",
      "COUNTRY_BOTS": {
        "TITLE": "Boty podľa krajiny",
        "DESC": "Táto schránka obsluhuje viac krajín. Konverzácia ide na bota svojej krajiny: podľa obchodu Kaufland, podľa trhu objednávky z Allegra, inak podľa jazyka, ktorým zákazník píše. Ostatné konverzácie idú na predvoleného bota vyššie.",
        "COUNTRY": "Vyberte krajinu",
        "BOT": "Vyberte bota",
        "ADD": "Pridať bota pre krajinu",
        "REMOVE": "Odstrániť",
        "DEFAULT_REQUIRED": "Najprv vyberte predvoleného bota. Bot krajiny ho nahrádza iba pre svoju krajinu.",
        "DISCONNECT_ALL": "Odpojiť všetkých botov"
      }
    },
    "ADD": {
      "TITLE": "Configure new bot",
      "CANCEL_BUTTON_TEXT": "Zrušiť",
      "API": {
        "SUCCESS_MESSAGE": "Bot bol úspešne pridaný.",
        "ERROR_MESSAGE": "Nepodarilo sa pridať bota. Skúste to prosím neskôr."
      }
    },
    "LIST": {
      "404": "No bots found. You can create a bot by clicking the 'Configure new bot' button ↗",
      "LOADING": "Načítavajú sa boty...",
      "TYPE": "Bot type",
      "TABLE_HEADER": {
        "DETAILS": "Detaily bota",
        "URL": "URL webhooku"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Vymazať",
      "TITLE": "Odstrániť bota",
      "SUBMIT": "Vymazať",
      "CANCEL_BUTTON_TEXT": "Zrušiť",
      "DESCRIPTION": "Are you sure you want to delete this bot? This action is irreversible.",
      "CONFIRM": {
        "TITLE": "Potvrdiť smazanie",
        "MESSAGE": "Naozaj chcete zmazať {name}?",
        "YES": "Ano, zmazať",
        "NO": "Ne, ponechat"
      },
      "API": {
        "SUCCESS_MESSAGE": "Bot bol úspešne odstránený.",
        "ERROR_MESSAGE": "Nepodarilo sa odstrániť bota. Skúste to prosím znova."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Upraviť",
      "LOADING": "Fetching bots...",
      "TITLE": "Upraviť bota",
      "CANCEL_BUTTON_TEXT": "Zrušiť",
      "API": {
        "SUCCESS_MESSAGE": "Bot bol úspešne aktualizovaný.",
        "ERROR_MESSAGE": "Nepodarilo sa aktualizovať bota. Skúste to prosím znova."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Avatar bota"
      },
      "NAME": {
        "LABEL": "Meno bota",
        "PLACEHOLDER": "Zadajte meno bota",
        "REQUIRED": "Meno bota je povinné"
      },
      "DESCRIPTION": {
        "LABEL": "Popis",
        "PLACEHOLDER": "Čo tento bot delá?"
      },
      "WEBHOOK_URL": {
        "LABEL": "URL webhooku",
        "PLACEHOLDER": "https://example.com/webhook",
        "REQUIRED": "URL webhooku je povinná"
      },
      "ERRORS": {
        "NAME": "Meno bota je povinné",
        "URL": "URL webhooku je povinná",
        "VALID_URL": "Zadajte prosím platnou URL začínající na http:// alebo https://"
      },
      "CANCEL": "Zrušiť",
      "CREATE": "Vytvoriť bota",
      "UPDATE": "Aktualizovať bota"
    },
    "WEBHOOK": {
      "DESCRIPTION": "Nakonfigurujte webhook bota pre integráciu s vašimi vlastnými službami. Bot bude prijímať a spracovávať udalosti z konverzácií a môže na ne odpovedať."
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot",
      "CSML": "CSML bot"
    }
  }
}
